import React from 'react';
import PropTypes from 'prop-types';

import {connectToJSContext} from '../utils.jsx';
import {getHeroBackgroundPicture} from '../helpers.jsx';

const Hero = ({ title, tagline, backgroundPicture, backgroundColor }) => (
    <section
        className="hs-hero"
        style={!backgroundPicture ? {backgroundColor} : {backgroundImage: `url(${backgroundPicture})`, backgroundColor}}
    >
        <h1 className="headline">{title}</h1>
        <p className="tagline">{tagline}</p>
    </section>
);

Hero.propTypes = {
    title: PropTypes.string.isRequired,
    tagline: PropTypes.string.isRequired,
    backgroundColor: PropTypes.string.isRequired,
    backgroundPicture: PropTypes.string
};

export {Hero};

const mapProductsStateToProps = (state) => ({
    title: state.theme_data.products_page.header_title,
    tagline: state.theme_data.products_page.header_tagline,
    backgroundPicture: getHeroBackgroundPicture(
        state.profile.products_hero_background_picture,
        state.theme_data.products_page.header_background_image,
        state.theme_data.header_background_image_list
    ),
    backgroundColor: state.theme_data.products_page.header_background_color
});
export const ProductsHero = connectToJSContext(mapProductsStateToProps)(Hero);

const mapNewsStateToProps = (state) => ({
    title: state.theme_data.news_page.header_title,
    tagline: state.theme_data.news_page.header_tagline,
    backgroundPicture: getHeroBackgroundPicture(
        state.profile.news_hero_background_picture,
        state.theme_data.news_page.header_background_image,
        state.theme_data.header_background_image_list
    ),
    backgroundColor: state.theme_data.news_page.header_background_color
});
export const NewsHero = connectToJSContext(mapNewsStateToProps)(Hero);

const mapEventsStateToProps = (state) => ({
    title: state.theme_data.events_page.header_title,
    tagline: state.theme_data.events_page.header_tagline,
    backgroundPicture: getHeroBackgroundPicture(
        state.profile.events_hero_background_picture,
        state.theme_data.events_page.header_background_image,
        state.theme_data.header_background_image_list
    ),
    backgroundColor: state.theme_data.events_page.header_background_color
});
export const EventsHero = connectToJSContext(mapEventsStateToProps)(Hero);

const mapAboutMeStateToProps = (state) => ({
    title: state.theme_data.about_page.header_title,
    tagline: state.theme_data.about_page.header_tagline,
    backgroundPicture: getHeroBackgroundPicture(
        state.profile.about_me_hero_background_picture,
        state.theme_data.about_page.header_background_image,
        state.theme_data.header_background_image_list
    ),
    backgroundColor: state.theme_data.about_page.header_background_color
});
export const AboutMeHero = connectToJSContext(mapAboutMeStateToProps)(Hero);

const mapCareersStateToProps = (state) => ({
    title: state.theme_data.careers_page.header_title,
    tagline: state.theme_data.careers_page.header_tagline,
    backgroundPicture: getHeroBackgroundPicture(
        state.profile.careers_page_hero_background_picture,
        state.theme_data.careers_page.header_background_image,
        state.theme_data.header_background_image_list
    ),
    backgroundColor: state.theme_data.careers_page.header_background_color ||
        state.theme_data.careers_page.header_background_color
});
export const CareersHero = connectToJSContext(mapCareersStateToProps)(Hero);



// WEBPACK FOOTER //
// ./components/hero/index.jsx